import { FaFileArrowDown } from "react-icons/fa6";
import saudiWakalaImage from "../../../assets/images/nta-wakala.jpg";
import { handleWakalaDownload, openLeadCaptureDownload } from "../../../utils/downloadHelpers";

const FaFileArrowDownIcon = FaFileArrowDown as React.ElementType;

interface DownloadBrochureProps {
  title: string | null | undefined;
  description?: string | null | undefined;
  pdfUrl: string | null | undefined;
  bgImg: string | null | undefined;
  saudiWakalaUrl?: string | null | undefined;
}
const Downloadbrochure = ({ title, description, pdfUrl, bgImg, saudiWakalaUrl }: DownloadBrochureProps) => {
  if (!pdfUrl) return null; // PDF nahi hai toh hide kar do

  const saudiWakalaFileUrl = saudiWakalaImage || saudiWakalaUrl || "#";

  return (
    <section className="bg-primary-lightblue">
      <div className="max-w-7xl mx-auto lg:px-6 md:px-10 px-4 xl:py-10 lg:py-16 py-5 flex flex-col md:flex-row items-center gap-10">
        {/* Text & Buttons */}
        <div className="flex-1">
          <h1 className="xl:text-5xl md:text-4xl text-3xl font-extrabold mb-3 leading-tight">
            <span className="text-primary-red">
              {title?.includes("Download") ? "Download " : ""}
            </span>
            <span className="text-primary-navyblue">
              {title?.replace("Download", "") || "Brochure"}
            </span>
          </h1>
          <p className="mb-8 text-primary-gray text-base font-medium leading-7">
            {description}
          </p>
          <div className="flex lg:flex-row flex-col gap-3 lg:w-[85%]">
            <button
              type="button"
              onClick={() => openLeadCaptureDownload({ fileUrl: pdfUrl || "#", title: "Download Brochure" })}
              className="flex gap-2 items-center bg-primary-red px-6 py-3 text-white font-bold text-center"
            >
              <FaFileArrowDownIcon className="text-white" />
              DOWNLOAD BROCHURE
            </button>

            {/* Saudi Wakala Link - Only show if URL exists in API */}
            {saudiWakalaFileUrl && (
              <button 
                type="button"
                onClick={() => handleWakalaDownload(saudiWakalaFileUrl)}
                className="flex gap-2 items-center border-2 border-primary-red px-6 py-3 text-primary-red font-bold text-center"
              >
                <FaFileArrowDownIcon className="text-primary-red" />   DOWNLOAD SAUDI WAKALA
              </button>
            )}
          </div>
        </div>
        {/* Illustration - replace with actual image */}
        <div>
          <img
            src={bgImg ?? undefined}
            alt={title ?? "Brochure"}
            className="w-full lg:h-[300px] h-[280px]"
          />
        </div>
      </div>
    </section>
  );
};

export default Downloadbrochure;
